export var LanguagesEnum;
(function (LanguagesEnum) {
    LanguagesEnum["EN"] = "en";
    LanguagesEnum["DE"] = "de";
})(LanguagesEnum || (LanguagesEnum = {}));
